export default __webpack_public_path__ + "static/media/fep-logo.647271ad.svg";